// import React from "react";
// import "./About.css";
// import Navbar from "../Navbar/Navbar";
// import { FaFacebook, FaLinkedin, FaTwitter } from "react-icons/fa";
// import Footer from "../Footer/Footer";
// import p1 from '../Images/p1.jpg'
// import p2 from '../Images/p2.png'
// import p3 from '../Images/p3.jpg'
// import p4 from '../Images/p4.jpg'
// import bg1 from '../Images/bg1.jpeg'

// const AboutUs = () => {
//   return (
//     <>
//       <Navbar />

//       <div className="about-page">
//         {/* Hero / Breadcrumb */}
//         <section className="about-hero">
//           <div className="container">
//             <h1>About Us</h1>
//             <p>
//               <a href="/">Home</a> / About Us
//             </p>
//           </div>
//         </section>

//         {/* Mission */}
//         <section className="about-section">
//           <div className="container">
//             <h2>Our mission is clear</h2>
//             {/* <p>
//             Our team of consultants and design engineers specialize in the
//             design of IBMS, AV, ELV, SECURITY, and ACOUSTICS, having many
//             years of hands-on experience in these domains. Established in the
//             year 2007, our founder has 40+ years of experience in the GCC
//             market, while our other senior associates bring in a wealth of
//             professional experience (15 to 20 years), creating an accumulated
//             150+ years of collective experience to the firm.
//           </p>
//           <p>
//             With an exceptional track record of having worked with international
//             brands like Marriott, Accor, Hilton, Hyatt, Kempinski, Pullman,
//             Starwood, Meraas, Musanada, Dubai Properties, Al Dar, Majed Al
//             Futtaim, Amity, Landmark, Masdar, etc., our infrastructure domain
//             knowledge is Best-in-Class, encompassing Hospitality, Governmental,
//             Corporate / Enterprise, Educational, Residential and Sports /
//             Stadiums sectors.
//           </p> */}
//             <p>
//               Our team of consultants and design engineers specializes in the design of integrated ELV systems,
//               encompassing Acoustics, Security, SRA, IT/ICT, IBMS, AV, Sustainability & Green Building, Project Management and supported by many years of hands-on experience across these domains.
//             We deliver dedicated expertise, ensuring performance-driven and compliant design solutions.
//             </p>
//           </div>
//         </section>

//         {/* Company Background */}
//         {/* <section className="about-section gray">
//         <div className="container">
//           <h2>Company Background</h2>
//           <p>
//             Established in 2007, INFOSIGHT designed and managed: 300+ Projects
//             <br />
//             <ul>
            
//             <li> 150+ Hotels,</li>
//             <li> 20+ Government Corporate Projects, 10+ Retails,  </li>
//             <li> 2 Stadiums,  </li>
//            <li>  4 Educational,  </li>
//             <li> 4 Hospitals  </li>
//             <li> Clinics,  </li>
//            <li>  1 Data Centre, 100+ </li>
//             <li> Residential  </li>
//             <li> Mixed Use,  </li>
//            <li>  3 Mosque Projects, </li>
//             <li> Emaar Hotel Projects, </li>
//            <li>  Large Data Centre Project (Airline - Dubai). </li>
//             </ul>
//           </p>
//           <p>
//             Infosight have worked with Al Dar Abu Dhabi to study flight path
//             noise impact for their Yas island golf course residential project.
//           </p>
//           <p>
//             In addition, we completed MAF (Majed Al Futtaim) for their multiple
//             city Centre & VOX cinema warm shell design projects.
//           </p>
//           <p>
//             We assure you that our AV specialist designers hold Infocomm’s CTS
//             certification along with other industry credentials and completed a
//             HEALTHCARE IT, AV, ICT & SECURITY design of a large multi-specialty
//             500 Bed-Hospital Project in Tirupati, Andhra Pradesh, India.
//           </p>
//           <p>
//             Most of the senior consultants have migrated from a System
//             Integration background with rich project execution experience and
//             now specialize on design consultancy and project management.
//           </p>
//         </div>
//       </section> */}

//         {/* Company Background */}
//         <section className="about-section gray">
//           <div className="container">
//             <h2>Company Background</h2>

//             {/* <p>
//       Infosight brings extensive experience in delivering complex design studies
//       and consultancy services for large-scale, master-planned developments,
//       including environmental and operational impact assessments for
//       noise-sensitive residential and mixed-use environments.
//     </p>

//     <p>
//       Our portfolio spans retail, entertainment, commercial, healthcare, and
//       public-sector developments, where we deliver coordinated, tenant-ready,
//       and future-focused design solutions across diverse asset classes.
//     </p>

//     <p>
//       Our consulting teams comprise certified and decorated specialists with
//       proven expertise in delivering integrated technology, infrastructure, and
//       building systems design solutions aligned with stringent operational,
//       compliance, and performance requirements.
//     </p>

//     <p>
//       A significant proportion of our senior consultants bring strong system
//       integration and project execution backgrounds, strengthening our design
//       consultancy and project management services with practical,
//       implementation-ready insights.
//     </p> */}
//             <p>

//               Established in 2007, the firm is led by a founder with over 40 years of experience in the GCC market.
//               Our senior associates contribute an additional 15–20 years of domain expertise each,
//               bringing together more than 150 years of cumulative professional experience within the organization.
//             </p>

//             <p>
//               With a strong track record of collaboration with renowned international brands such as
//               Marriott, Accor, Hilton, Hyatt, Kempinski, Pullman, Starwood, Meraas, Musanada, Dubai Properties, Aldar, Majid Al Futtaim, Amity, Landmark,
//               and Masdar, we offer best-in-class infrastructure domain knowledge.
//               Our experience spans Hospitality, Government, Corporate and Enterprise, Education, Residential, and Sports and Stadium developments.
//             </p>
//           </div>
//         </section>


//         {/* Experience Highlights */}
//         <section className="about-highlights">
//           <div className="container highlights">
//             <div className="highlight-box">
//               <h3>20+</h3>
//               <p>Years' Experience</p>
//             </div>
//             <div className="highlight-box">
//               <h3>500+</h3>
//               <p>Projects Delivered</p>
//             </div>
//           </div>
//         </section>

//         {/* Management */}
//         <section className="about-section">
//           <div className="container">
//             <h2>Our Management</h2>

//             <div className="management">
//               <div className="manager">
//                 <div className="manager-img">
//                   <img src={p1} alt="K S N Prasad" className="manager-image" />
//                 </div>
//                 <h3>K S N Prasad</h3>
//                 <p>Managing Director</p>
//                 <p>
//                   Mr. Prasad has more than 3 decades of rich and varied experience
//                   in the field of IT infrastructure, low-current systems, ICT, AV,
//                   and various ELV systems...
//                 </p>
//               </div>

//               {/* <div className="manager">
//                <div className="manager-img">
//         <img src={p2} alt="Vamsidhar Babu Komatineni" className="manager-image1" />
//         </div>
//         <h3>Vamsidhar Babu Komatineni</h3>
//         <p>Managing Director - India</p>
//         <p>
//           Mr. Vamsidhar is a highly accomplished professional with over 36
//           years of diverse experience spanning manufacturing, consultancy,
//           real estate, and training...
//         </p>
//       </div> */}
//               <div className="manager">
//                 <div className="manager-bg1">
//                   <div className="manager-img1">
//                     <img
//                       src={p2}
//                       alt="Vamsidhar Babu Komatineni"
//                       className="manager-image1"
//                     />
//                   </div>
//                 </div>

//                 <h3 style={{ marginTop: '50px' }}>Vamsidhar Babu Komatineni</h3>
//                 <p>Managing Director - India</p>
//                 <p>
//                   Mr. Vamsidhar is a highly accomplished professional with over 36 years of
//                   diverse experience spanning manufacturing, consultancy, real estate, and
//                   training...
//                 </p>
//               </div>

//               <div className="manager">
//                 <div className="manager-img">
//                   <img src={p3} alt="Suresh Kumar G" className="manager-image" />
//                 </div>
//                 <h3>Suresh Kumar G</h3>
//                 <p>Executive Director</p>
//                 <p>
//                   Mr. Suresh Kumar has over 27 years of experience in the field of
//                   technology and more than 17 years of consulting experience in
//                   the IT/AV/security/ELV fields...
//                 </p>
//               </div>

//               <div className="manager">
//                 <div className="manager-img">
//                   <img src={p4} alt="Roshan M Thomas" className="manager-image" />
//                 </div>
//                 <h3>Roshan M Thomas</h3>
//                 <p>Principal Consultant</p>
//                 <p>
//                   An Instrumentation & Electronics Engineer, with professional
//                   experience for the past twelve years in the field of security
//                   consulting and management...
//                 </p>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>


//       <Footer />
//     </>
//   );
// };

// export default AboutUs;


import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import {
  FiChevronRight,
  FiAward,
  FiTrendingUp,
  FiUserCheck,
  FiGlobe,
  FiCheckCircle,
} from "react-icons/fi";

// Image Imports
import p1 from "../Images/p1.jpg";
import p2 from "../Images/p2.png";
import p3 from "../Images/p3.jpg";
import p4 from "../Images/p4.jpg";

// Eye-Comfort High-End Real Estate & Architectural Palette
const theme = {
  bgApp: "#F8FAF9",
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A", // Deep Slate Navy
  accent: "#0D9488", // Soft Emerald Teal
  accentLight: "#CCFBF1",
  accentHover: "#0F766E",
  gold: "#D97706", // Muted Architectural Gold
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
  shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
};

// Global Responsive Injection
const inlineStyles = `
  .about-rich-page {
    background-color: ${theme.bgApp};
    color: ${theme.textDark};
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    min-height: 100vh;
  }

  /* Hero Banner */
  .about-hero-header {
    background: linear-gradient(180deg, ${theme.primary} 0%, #1E293B 100%);
    padding: 70px 20px 80px;
    text-align: center;
    color: #FFFFFF;
    position: relative;
  }

  /* Content Containers */
  .about-max-wrapper {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
  }

  /* Mission & Background Split Grid */
  .about-overview-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    margin-top: -40px;
    position: relative;
    z-index: 10;
  }

  .about-card-box {
    background-color: ${theme.bgCard};
    border-radius: 20px;
    padding: 36px;
    border: 1px solid ${theme.border};
    box-shadow: ${theme.shadowMd};
  }

  /* Metrics Highlights Ribbon */
  .about-stats-ribbon {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 24px;
    margin: 50px 0;
  }

  .about-stat-item {
    background-color: ${theme.bgCard};
    border: 1px solid ${theme.border};
    border-radius: 16px;
    padding: 28px 20px;
    text-align: center;
    box-shadow: ${theme.shadowSm};
    transition: transform 0.3s ease, border-color 0.3s ease;
  }

  .about-stat-item:hover {
    transform: translateY(-4px);
    border-color: ${theme.accent};
  }

  /* Leadership Grid */
  .management-team-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    gap: 28px;
    margin-top: 32px;
  }

  .manager-profile-card {
    background-color: ${theme.bgCard};
    border-radius: 18px;
    border: 1px solid ${theme.border};
    padding: 24px;
    box-shadow: ${theme.shadowSm};
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .manager-profile-card:hover {
    transform: translateY(-6px);
    box-shadow: ${theme.shadowMd};
    border-color: ${theme.accent};
  }

  .manager-avatar-frame {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid ${theme.accentLight};
    box-shadow: ${theme.shadowSm};
    margin-bottom: 16px;
    background-color: ${theme.bgSubtle};
  }

  .manager-avatar-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 992px) {
    .about-overview-grid {
      grid-template-columns: 1fr;
      margin-top: 20px;
    }
  }

  @media (max-width: 600px) {
    .about-card-box {
      padding: 24px;
    }
    .about-hero-header {
      padding: 50px 20px 60px;
    }
  }
`;

const AboutUs = () => {
  const managementList = [
    {
      name: "K S N Prasad",
      role: "Managing Director",
      image: p1,
      bio: "Mr. Prasad has more than 3 decades of rich and varied experience in the field of IT infrastructure, low-current systems, ICT, AV, and various ELV systems.",
    },
    {
      name: "Vamsidhar Babu Komatineni",
      role: "Managing Director - India",
      image: p2,
      bio: "Mr. Vamsidhar is a highly accomplished professional with over 36 years of diverse experience spanning manufacturing, consultancy, real estate, and training.",
    },
    {
      name: "Suresh Kumar G",
      role: "Executive Director",
      image: p3,
      bio: "Mr. Suresh Kumar has over 27 years of experience in technology and more than 17 years of consulting experience in IT, AV, Security, and ELV domains.",
    },
    {
      name: "Roshan M Thomas",
      role: "Principal Consultant",
      image: p4,
      bio: "An Instrumentation & Electronics Engineer with professional experience over 12 years in security consulting, risk assessment, and system management.",
    },
  ];

  const brandLogos = [
    "Marriott",
    "Accor",
    "Hilton",
    "Hyatt",
    "Kempinski",
    "Pullman",
    "Starwood",
    "Meraas",
    "Musanada",
    "Dubai Properties",
    "Aldar",
    "Majid Al Futtaim",
  ];

  return (
    <div className="about-rich-page">
      <style>{inlineStyles}</style>
      <Navbar />

      {/* Hero Header */}
      <section className="about-hero-header">
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <span
            style={{
              color: theme.accentLight,
              fontWeight: "600",
              fontSize: "0.85rem",
              letterSpacing: "1.2px",
              textTransform: "uppercase",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              padding: "6px 16px",
              borderRadius: "20px",
              display: "inline-block",
              marginBottom: "12px",
            }}
          >
            Our Profile
          </span>

          <h1 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "12px" }}>
            About Infosight
          </h1>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: "0.875rem",
            }}
          >
            <span style={{ cursor: "pointer" }} onClick={() => (window.location.href = "/")}>
              Home
            </span>
            <FiChevronRight size={12} />
            <span style={{ color: theme.accentLight, fontWeight: "600" }}>About Us</span>
          </div>
        </div>
      </section>

      {/* Overview Split Section */}
      <div className="about-max-wrapper">
        <div className="about-overview-grid">
          {/* Mission Card */}
          <div className="about-card-box">
            <span
              style={{
                color: theme.accent,
                fontWeight: "600",
                fontSize: "0.825rem",
                letterSpacing: "1.2px",
                textTransform: "uppercase",
                backgroundColor: theme.accentLight,
                padding: "6px 14px",
                borderRadius: "20px",
                display: "inline-block",
                marginBottom: "16px",
              }}
            >
              Our Mission
            </span>

            <h2
              style={{
                fontSize: "1.6rem",
                fontWeight: "800",
                color: theme.primary,
                marginBottom: "16px",
                lineHeight: "1.3",
              }}
            >
              Delivering Performance-Driven Design Solutions
            </h2>

            <p
              style={{
                color: theme.textMuted,
                fontSize: "1rem",
                lineHeight: "1.7",
                marginBottom: "16px",
              }}
            >
              Our team of consultants and design engineers specializes in the design of integrated ELV systems, encompassing Acoustics, Security, SRA, IT/ICT, IBMS, AV, Sustainability & Green Building, and Project Management.
            </p>

            <p style={{ color: theme.textMuted, fontSize: "1rem", lineHeight: "1.7" }}>
              Supported by many years of hands-on experience across these specialized domains, we deliver dedicated expertise ensuring compliant and scalable design solutions.
            </p>
          </div>

          {/* Background Card */}
          <div className="about-card-box">
            <span
              style={{
                color: theme.accent,
                fontWeight: "600",
                fontSize: "0.825rem",
                letterSpacing: "1.2px",
                textTransform: "uppercase",
                backgroundColor: theme.accentLight,
                padding: "6px 14px",
                borderRadius: "20px",
                display: "inline-block",
                marginBottom: "16px",
              }}
            >
              Company Background
            </span>

            <h2
              style={{
                fontSize: "1.6rem",
                fontWeight: "800",
                color: theme.primary,
                marginBottom: "16px",
                lineHeight: "1.3",
              }}
            >
              Over 150+ Years of Cumulative Expertise
            </h2>

            <p
              style={{
                color: theme.textMuted,
                fontSize: "1rem",
                lineHeight: "1.7",
                marginBottom: "16px",
              }}
            >
              Established in 2007, the firm is led by a founder with over 40 years of experience in the GCC market. Our senior associates contribute an additional 15–20 years of domain expertise each.
            </p>

            <p style={{ color: theme.textMuted, fontSize: "1rem", lineHeight: "1.7" }}>
              With a strong track record of collaboration with renowned international brands, our experience spans Hospitality, Government, Corporate, Education, Residential, and Stadium developments.
            </p>
          </div>
        </div>

        {/* Key Metrics Highlights */}
        <div className="about-stats-ribbon">
          <div className="about-stat-item">
            <FiAward size={28} color={theme.accent} style={{ marginBottom: "12px" }} />
            <h3 style={{ fontSize: "2rem", fontWeight: "800", color: theme.primary, margin: 0 }}>
              200+
            </h3>
            <p style={{ color: theme.textMuted, fontSize: "0.9rem", fontWeight: "600", margin: "4px 0 0" }}>
              Years of Industry Leadership
            </p>
          </div>

          <div className="about-stat-item">
            <FiTrendingUp size={28} color={theme.accent} style={{ marginBottom: "12px" }} />
            <h3 style={{ fontSize: "2rem", fontWeight: "800", color: theme.primary, margin: 0 }}>
              400+
            </h3>
            <p style={{ color: theme.textMuted, fontSize: "0.9rem", fontWeight: "600", margin: "4px 0 0" }}>
              Projects Completedm
            </p>
          </div>

          <div className="about-stat-item">
            <FiUserCheck size={28} color={theme.accent} style={{ marginBottom: "12px" }} />
            <h3 style={{ fontSize: "2rem", fontWeight: "800", color: theme.primary, margin: 0 }}>
              150+
            </h3>
            <p style={{ color: theme.textMuted, fontSize: "0.9rem", fontWeight: "600", margin: "4px 0 0" }}>
              Years Cumulative Experience
            </p>
          </div>

          <div className="about-stat-item">
            <FiGlobe size={28} color={theme.accent} style={{ marginBottom: "12px" }} />
            <h3 style={{ fontSize: "2rem", fontWeight: "800", color: theme.primary, margin: 0 }}>
              GCC & Asia
            </h3>
            <p style={{ color: theme.textMuted, fontSize: "0.9rem", fontWeight: "600", margin: "4px 0 0" }}>
              Global Footprint
            </p>
          </div>
        </div>

        {/* Global Clients Mention */}
        <div
          style={{
            backgroundColor: theme.bgCard,
            borderRadius: "20px",
            padding: "36px",
            border: `1px solid ${theme.border}`,
            boxShadow: theme.shadowSm,
            marginBottom: "60px",
          }}
        >
          <h3
            style={{
              fontSize: "1.25rem",
              fontWeight: "700",
              color: theme.primary,
              marginBottom: "16px",
              textAlign: "center",
            }}
          >
            Collaborations With World-Class Brands & Developers
          </h3>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            {brandLogos.map((brand, idx) => (
              <span
                key={idx}
                style={{
                  backgroundColor: theme.bgSubtle,
                  color: theme.textDark,
                  border: `1px solid ${theme.border}`,
                  padding: "8px 16px",
                  borderRadius: "20px",
                  fontSize: "0.875rem",
                  fontWeight: "600",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <FiCheckCircle size={14} color={theme.accent} /> {brand}
              </span>
            ))}
          </div>
        </div>

        {/* Leadership Management Section */}
        <section style={{ marginBottom: "60px" }}>
          <div style={{ textAlign: "center", maxWidth: "700px", margin: "0 auto" }}>
            <span
              style={{
                color: theme.accent,
                fontWeight: "600",
                fontSize: "0.825rem",
                letterSpacing: "1.2px",
                textTransform: "uppercase",
                backgroundColor: theme.accentLight,
                padding: "6px 14px",
                borderRadius: "20px",
                display: "inline-block",
                marginBottom: "12px",
              }}
            >
              Executive Leadership
            </span>

            <h2 style={{ fontSize: "2rem", fontWeight: "800", color: theme.primary }}>
              Our Management Team
            </h2>

            <p style={{ color: theme.textMuted, fontSize: "0.95rem", marginTop: "8px" }}>
              Guided by veteran industry experts with decades of hands-on technical and consulting achievements.
            </p>
          </div>

          <div className="management-team-grid">
            {managementList.map((m, idx) => (
              <div key={idx} className="manager-profile-card">
                <div className="manager-avatar-frame">
                  <img src={m.image} alt={m.name} className="manager-avatar-img" />
                </div>

                <h3 style={{ fontSize: "1.1rem", fontWeight: "700", color: theme.primary, margin: 0 }}>
                  {m.name}
                </h3>

                <span
                  style={{
                    fontSize: "0.825rem",
                    fontWeight: "600",
                    color: theme.accent,
                    margin: "4px 0 12px",
                  }}
                >
                  {m.role}
                </span>

                <p
                  style={{
                    color: theme.textMuted,
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                    margin: 0,
                  }}
                >
                  {m.bio}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;